import React from 'react';
import { Card, Button, Tag } from 'antd';
import { useNavigate } from 'react-router-dom';
import { DataTable, PageLayout } from '../../ui';
import { useGetLayoutsQuery, useCreateLayoutMutation } from '../../store/api/calculationsApi';

// Простая страница-плейсхолдер списка: пока загрузим по id=1, позже добавим полноценный список из /calculations/layouts
const CalculationsListPage: React.FC = () => {
  const navigate = useNavigate();
  const { data } = useGetLayoutsQuery({ page: 1, limit: 20 });
  const [createLayout] = useCreateLayoutMutation();

  return (
    <PageLayout
      title="Расчёты размещения"
      subtitle="Планирование загрузки и размещения груза"
      actions={
        <Button
          type="primary"
          onClick={async () => {
            const draft: any = await createLayout({ inputPayload: { source: 'manual' } }).unwrap();
            navigate(`/calculations/${draft.id}`);
          }}
        >
          Создать расчёт
        </Button>
      }
    >
      <Card>
      <DataTable
        rowKey="id"
        dataSource={data?.items || []}
        columns={[
          { title: 'ID', dataIndex: 'id', key: 'id' },
          { title: 'Статус', dataIndex: 'status', key: 'status', render: (s) => <Tag color={s === 'DRAFT' ? 'default' : 'blue'}>{s}</Tag> },
          { title: 'Создан', dataIndex: 'createdAt', key: 'createdAt', render: (d) => d ? new Date(d).toLocaleString('ru-RU') : '—' },
          { title: 'Действия', key: 'actions', render: (_, r: any) => <Button type="link" onClick={() => navigate(`/calculations/${r.id}`)}>Открыть</Button> }
        ]}
        pagination={false}
      />
      </Card>
    </PageLayout>
  );
};

export default CalculationsListPage;


